import { Currency } from '@/models/currency';

import { Event } from './event';

export class CurrenciesAcquiredEvent extends Event<Readonly<Currency[]>> {}
